import React from 'react'
import { Box, Typography, Card, CardContent } from '@material-ui/core'
import { useStyles } from './styles'
import ReportStatus from 'web/src/app/root/components/common/report-status'
import { useSelector } from 'react-redux'
import { getFormattedDate, getReportTypeText } from 'web/src/utils'
import { NavLink } from 'react-router-dom'
import { REPORT_TYPES } from 'web/src/app/root/hooks/useReportTypes'
import { CatchReplacedIcon } from 'web/src/app/root/components/common/catch-replaced-icon'
import { WarningReplacedIcon } from 'web/src/app/root/components/common/warning-replaced-icon'

export const DeviceReports = ({ reports, device }) => {
    const classes = useStyles()
    const { theme, locale } = useSelector(state => state.main)

    return (
        <Box>
            <NavLink
                className={classes.link}
                style={{ textDecoration: 'underline' }}
                to={`/devices/${device.id}/reports`}
            >
                <Typography className={classes.deviceReportsLink}>
                    {locale.reports.reports}
                </Typography>
            </NavLink>
            {reports?.length ? (
                <Card className={classes.deviceReportsCard}>
                    {reports?.map((report, index) => {
                        return (
                            <NavLink
                                key={index}
                                style={{
                                    color: theme.primary,
                                    textDecoration: 'none'
                                }}
                                to={`/reports/${report.id}`}
                            >
                                <CardContent
                                    className={classes.deviceReportsCardContent}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 10
                                        }}
                                    >
                                        {report.replaced_type ===
                                            REPORT_TYPES.catch ||
                                        report.replaced_type ===
                                            REPORT_TYPES.false_triggering ? (
                                            <>
                                                {report.replaced_type ===
                                                REPORT_TYPES.catch ? (
                                                    <CatchReplacedIcon
                                                        size={24}
                                                    />
                                                ) : null}
                                                {report.replaced_type ===
                                                REPORT_TYPES.false_triggering ? (
                                                    <WarningReplacedIcon
                                                        size={24}
                                                    />
                                                ) : null}
                                                <span
                                                    style={{
                                                        textDecoration:
                                                            'line-through',
                                                        fontSize: 16
                                                    }}
                                                >
                                                    {getReportTypeText(
                                                        {
                                                            ...report,
                                                            report_type:
                                                                report.replaced_type
                                                        },
                                                        locale
                                                    )}
                                                </span>
                                                <span style={{ fontSize: 16 }}>
                                                    →
                                                </span>
                                            </>
                                        ) : null}
                                        <ReportStatus
                                            report={report}
                                            theme={theme}
                                        />
                                        <Typography
                                            style={{
                                                width: 140,
                                                textDecoration: 'underline'
                                            }}
                                            noWrap
                                        >
                                            {getReportTypeText(report, locale)}
                                        </Typography>
                                    </div>
                                    <Typography
                                        style={{
                                            paddingLeft: 20,
                                            textDecoration: 'underline'
                                        }}
                                    >
                                        {getFormattedDate(report.created_at)}
                                    </Typography>
                                </CardContent>
                            </NavLink>
                        )
                    })}
                </Card>
            ) : (
                <Typography>{locale.devices.noReportsYet}</Typography>
            )}
        </Box>
    )
}
